import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Sparkles } from "lucide-react";
import SleekButton from "@/components/ui/NavButtons";

const APP_URL = "https://app.vawena.ai";

export const CallToAction: React.FC = () => {
  return (
    <section className="px-4 sm:px-6 pb-20 mx-auto max-w-[900px]">
      <div className="relative overflow-hidden rounded-3xl dark:border dark:border-white/10 border border-blue-300 dark:bg-gradient-to-br dark:from-[#1a2a5e] dark:to-[#0a1535] bg-gradient-to-br from-blue-600 to-indigo-700 px-8 py-12 text-center">
        {/* Subtle glow */}
        <div className="absolute inset-0 bg-gradient-to-br from-blue-400/10 via-transparent to-indigo-400/10 pointer-events-none" />

        <div className="relative z-10">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full dark:bg-white/10 bg-white/20 dark:border dark:border-white/15 border border-white/30 text-white text-xs font-semibold uppercase tracking-widest mb-5">
            <Sparkles className="w-3.5 h-3.5 text-blue-200" />
            More coming soon
          </div>

          <h2 className="text-2xl sm:text-3xl font-extrabold text-white mb-3 leading-tight">
            We're just getting started.
          </h2>
          <p className="text-blue-100 text-sm sm:text-base leading-relaxed max-w-xl mx-auto mb-8">
            WealthScope and PortfolioIQ are live now. Additional modules — advanced market intelligence, AI portfolio optimization, and more — are in development. Join today and get early access as they launch.
          </p>

          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <a href={`${APP_URL}/signup`} rel="noopener noreferrer" className="inline-flex">
              <SleekButton
                type="button"
                variant="primary"
                className="!h-12 !px-8 !py-3 !rounded-full !text-sm !font-semibold !min-w-0"
              >
                <span className="inline-flex items-center gap-2">
                  Start free trial <ArrowRight className="w-4 h-4" />
                </span>
              </SleekButton>
            </a>
            <Link to="/contact" className="inline-flex">
              <SleekButton
                type="button"
                variant="light"
                className="!h-12 !px-8 !py-3 !rounded-full !text-sm !font-semibold !min-w-0 dark:!bg-white/[0.08] dark:!text-white dark:border-white/30"
              >
                Talk to sales
              </SleekButton>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};
